export function getFaqSectionStyles(_, { palette }) {
  return {
    faqContainer: {
      width: '100%',
      background: '#F6F6F6',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    faqInnerContainer: {
      width: '1180px',
      '@media only screen and (max-width: 1200px)': {
        width: '702px',
      },
      '@media only screen and (max-width: 720px)': {
        width: '362px',
      },
    },
    faqHeader: {
      width: '100%',
      fontSize: '52px',
      fontWeight: '600',
      textAlign: 'center',
      paddingTop: '122px',
      paddingBottom: '86px',
      color: palette.black,
      '@media only screen and (max-width: 1200px)': {
        fontSize: '32px',
        width: '702px',
        paddingTop: '103px',
        paddingBottom: '64px',
      },
      '@media only screen and (max-width: 720px)': {
        fontSize: '32px',
        width: '362px',
        paddingTop: '65px',
        paddingBottom: '64px',
      },
    },
    faqAccordionsContainer: {
      width: '100%',
      marginBottom: '213px',
      '@media only screen and (max-width: 1200px)': {
        marginBottom: '99px',
      },
      '@media only screen and (max-width: 720px)': {
        marginBottom: '103px',
      },
    },
    moreLink: {
      fontSize: '20px',
      lineHeight: '133%',
    },
  };
}
